import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { truncate } from 'lodash';
import useMediaQuery from 'react-use-media-query-hook';

import Card from '../../main/containers/channel/CardCurrent';
import { CURRENT_TEMPLATE_NAME } from '../../main/utils/const';
import { getCurrentCanvasIcon } from '../../main/utils/helpers/getCurrentCanvasIcon';
import SectionHeaderWeb from '../../main/components/SectionHeaderWeb';
import { getColorDependsOnBackground } from '../../main/utils/helpers/getColorDependsOnBackground';

const Channels = ({
  locales,
  locales: {
    portfolioWeb,
    channel: {
      intro: { card },
    },
  },
  styleColor,
  isFourthColorPaletteNumber = false,
}) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [activeCardId, setActiveCardId] = useState(null);
  const { channels } = useSelector((state) => state.portfolio);
  const { collection } = useSelector((state) => state.channel);

  const activeCardData = useMemo(() => {
    if (collection.length && !activeCardId) {
      setActiveCardId(collection[0].id);
      return collection[0];
    }
    return collection.find((i) => i.id === activeCardId);
  }, [collection, activeCardId]);

  const singleCard = activeCardData && (
    <Card
      locales={locales}
      isPreview
      styleColor={styleColor}
      templateName={CURRENT_TEMPLATE_NAME}
      backgroundImage={`${styleColor}80`}
      card={{
        ...card,
        ...activeCardData,
        title: null,
      }}
    />
  );

  return (
    <div className="channels section">
      {getCurrentCanvasIcon('ChannelsCanvas', styleColor)}

      <SectionHeaderWeb
        templateName={CURRENT_TEMPLATE_NAME}
        title={portfolioWeb.channels}
        description={channels.description}
        className="green-title"
        style={{ color: styleColor }}
      />

      <div className="cards-section">
        <div className="left">
          {isMobile
            ? collection.map((channel) => {
                return (
                  <Card
                    locales={locales}
                    className="margin-top-20"
                    isPreview
                    styleColor={styleColor}
                    templateName={CURRENT_TEMPLATE_NAME}
                    backgroundImage={`${styleColor}80`}
                    card={{
                      ...card,
                      ...channel,
                      title: null,
                    }}
                  />
                );
              })
            : singleCard}
        </div>
        <div className="right">
          {collection.map(({ id, name }) => (
            <div
              key={id}
              onClick={() => setActiveCardId(id)}
              className={classnames('item custom-font-body', {
                active: activeCardId === id,
              })}
              style={{
                backgroundColor: activeCardId === id && styleColor,
                color:
                  isFourthColorPaletteNumber &&
                  activeCardId === id &&
                  getColorDependsOnBackground(styleColor),
              }}
            >
              {truncate(name, { length: 30 })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Channels;
